import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Logger } from '../../shared/logger';
import { ErrorMessages } from '../../shared/error/error-messages';
import { ParteDiario } from '../models';
import { QueryBuilder } from '../query';
import { map } from 'rxjs/operators';
import { AlertController, MenuController } from '@ionic/angular';
import { Timestamp } from 'firebase/firestore';
import { PAGES } from '../../../app/app.constants';
import { Router } from '@angular/router';

@Injectable()
export class ParteDiarioService extends RestService<ParteDiario> {

  constructor(
    protected errorMessages: ErrorMessages,
    protected afAuth: AngularFireAuth,
    protected store: AngularFirestore,
    protected logger: Logger,
    protected alertController: AlertController,
    protected router: Router,
    protected menuController: MenuController
  ) {
    super(errorMessages, afAuth, store, logger, 'parte_diario');
  }

  getParteDiarioActivo(uid: string) {
    let builder = QueryBuilder.new();
    builder.where('user.uid', '==', uid);
    builder.where('activo', '==', true);
    builder.limit(1);
    return this.allWith(builder.build()).pipe(
      map((res: ParteDiario[]) => {
        if (res && Array.isArray(res))
          return res[0]
        return res;
      }
      ))
  }

  verificarParteActivo(isMaquinista: boolean, parteDiario: ParteDiario) {
    if (isMaquinista && parteDiario?.activo) {
      const fechaInicio = parteDiario.fecha_inicio.toDate(); // Convertir a Date
      const hoy = new Date();
      
      // Obtener la fecha de hoy sin horas, minutos ni segundos
      hoy.setHours(0, 0, 0, 0);
  
      // Si la fecha de inicio es anterior a hoy, mostrar mensaje
      if (fechaInicio < hoy) {
        this.msgParteActivoOneDay();
      }
    }
  }

  async msgParteActivoOneDay() {

    this.menuController.close('menu');

    const alert = await this.alertController.create({
      cssClass: 'radio-alert',
      backdropDismiss: false,
      header: 'Parte diario activo',
      subHeader: 'Por más de 24hs',
      message: `Existe un parte diario que está activo por más de 24 horas.
                Por favor, finalice el parte activo e inicie uno nuevo.`,
      buttons: [ {
          text: 'Abrir parte diario',
          cssClass: 'button-footer-cuadrado',
          handler: (data) => {
            this.router.navigate([PAGES.PARTE_DIARIO_DETALLE[0]])
          }
        }
      ]
    });
    await alert.present();
  }

}
